import type {
  PersistStorage,
  StateStorage,
  StorageValue,
} from 'zustand/middleware';
import superjson from 'superjson';

/**
 * Similar to createJSONStorage, but uses superjson to preserve Date and other complex types.
 */
export function createSuperJSONStorage<T = unknown>(
  getStorage: () => StateStorage,
): PersistStorage<T> {
  return {
    getItem: (name: string) => {
      const storage = getStorage();
      const str = storage.getItem(name);

      const parse = (value: string | null): StorageValue<T> | null => {
        if (!value) return null;
        try {
          return superjson.parse(value) as StorageValue<T>;
        } catch {
          return null;
        }
      };

      if (str instanceof Promise) {
        return str.then(parse);
      }
      return parse(str);
    },
    setItem: (name, value) => {
      return getStorage().setItem(name, superjson.stringify(value));
    },
    removeItem: (name) => {
      return getStorage().removeItem(name);
    },
  };
}
